module.exports = __webpack_public_path__ + "img/bg1.3d79e4e5.png";